import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Loading from "../../components/common/loading";
import {
  fetchProfile,
  fetchTempProfiles,
  fetchTestRecords,
} from "../../services/dashboard";
import UserProfile from "../../components/dashboard/profile";
import TempProfilesList from "../../components/dashboard/tempProfilesList";
import ProfileRecordsList from "../../components/dashboard/profileRecordsList";
import Tabs from "../../components/common/tabs";
import DashboardLayout from "../../layout/dashboardLayout";

const DashboardProfile = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [profileTempProfiles, setProfileTempProfiles] = useState(null);
  const [profileRecords, setProfileRecords] = useState(null);
  const [recordsPage, setRecordsPage] = useState(1);
  const [profilesPage, setProfilesPage] = useState(1);

  const testRecordsHandler = (id: string) => {
    fetchTestRecords(id, recordsPage).then((test_records) =>
      setProfileRecords(test_records.data)
    );
  };

  const tempProfilesHandler = (id: string) => {
    fetchTempProfiles(id, profilesPage).then((temp_profiles) =>
      setProfileTempProfiles(temp_profiles.data)
    );
  };

  useEffect(() => {
    if (id) testRecordsHandler(id);
  }, [recordsPage]);

  useEffect(() => {
    if (id) tempProfilesHandler(id);
  }, [profilesPage]);

  useEffect(() => {
    if (id)
      fetchProfile(id).then((response) => {
        setProfile(response.data);
        setLoading(false);

        // if (response.data.temp_user_count > 0 && !profileTempProfiles)
        //   tempProfilesHandler(id);
        // if (response.data.test_count > 0 && !profileRecords)
        //   testRecordsHandler(id);
      });
  }, [id]);

  const tabItems = [
    {
      id: 0,
      title: "پروفایل",
      content: <div>{!loading && <UserProfile profile={profile} />}</div>,
    },
    {
      id: 1,
      title: "زیرمجموعه‌ها",
      content: (
        <div>
          {profileTempProfiles ? (
            <TempProfilesList
              data={profileTempProfiles}
              profilesPage={profilesPage}
              setProfilesPage={setProfilesPage}
            />
          ) : (
            <p className="text-center mt-6"> زیرمجموعه‌ای ایجاد نشده‌ است</p>
          )}
        </div>
      ),
    },
    {
      id: 2,
      title: "آزمایش‌ها",
      content: (
        <div>
          {profileRecords ? (
            <ProfileRecordsList
              data={profileRecords}
              user_record={id}
              recordsPage={recordsPage}
              setRecordsPage={setRecordsPage}
            />
          ) : (
            <p className="text-center mt-6"> آزمایشی ایجاد نشده‌ است</p>
          )}
        </div>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <div className="my-10">
        <div className="breadcrumbs text-sm">
          <ul>
            <li>
              <Link to="/dashboard">داشبورد</Link>
            </li>
            <li>
              <Link to="/dashboard-profiles">کاربران بادی‌بان</Link>
            </li>
            <li className="font-[900]">
              {
                <span className="-mt-1">
                  {
                    //@ts-ignore
                    profile?.user?.first_name
                  }{" "}
                  {
                    //@ts-ignore
                    profile?.user?.last_name
                  }
                </span>
              }
            </li>
          </ul>
        </div>

        {loading ? <Loading /> : <Tabs tabItems={tabItems} />}
      </div>
    </DashboardLayout>
  );
};

export default DashboardProfile;
